import { Card, List, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GaiaLoadingHelperV2 } from "~/modules/app/components/GaiaLoadingHelperV2";
import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";

import { FeedbackListItem } from "./FeedbackListItem";
import { useReportsHavingFeedback } from "./useReportsHavingFeedback";

export function FieldworkerFeedbackListScreen() {
    const { t } = useTranslation("fieldworker");
    const { data, error, loading } = useReportsHavingFeedback();

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageComponent title={t("FieldworkerFeedbackListScreen.title")}>
                <Typography variant="subtitle1" sx={{ padding: 1 }}>
                    {t("FieldworkerFeedbackListScreen.subtitle")}
                </Typography>

                <GaiaLoadingHelperV2
                    data={data}
                    error={error}
                    loading={loading}
                    render={retVal =>
                        retVal.length > 0 ? (
                            <List sx={{ display: "flex", flexDirection: "column", rowGap: 1 }}>
                                {data.map(element => (
                                    <FeedbackListItem key={element.area} data={element} />
                                ))}
                            </List>
                        ) : (
                            <Card variant="outlined">
                                <Typography variant="h6" textAlign="center" py="32px">
                                    {t("FieldworkerFeedbackListScreen.noFeedback")}
                                </Typography>
                            </Card>
                        )
                    }
                />
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
